import { useMemo } from 'react';
import { uniqBy, values } from 'lodash';
import { useDropdownOptions, useDropdownValue } from '../../../../../../../hooks';
import { BID_STRATEGIES } from '../../../config';

export const bidStrategiesCategory = {
    MAX_CONVERSIONS: 'MAX_CONVERSIONS',
    MAX_VALUE: 'MAX_VALUE',
    BID_CONTROL: 'BID_CONTROL',
    BID_MODIFIER: 'BID_MODIFIER',
};

export const categoryToStrategyMap = {
    [bidStrategiesCategory.BID_CONTROL]: BID_STRATEGIES.SMART,
    [bidStrategiesCategory.MAX_CONVERSIONS]: BID_STRATEGIES.MAX_CONVERSIONS,
    [bidStrategiesCategory.MAX_VALUE]: BID_STRATEGIES.MAX_VALUE,
};

export const strategyToCategoryMap = {
    [BID_STRATEGIES.SMART]: bidStrategiesCategory.BID_CONTROL,
    [BID_STRATEGIES.FIXED]: bidStrategiesCategory.BID_CONTROL,
    [BID_STRATEGIES.TARGET_CPA]: bidStrategiesCategory.MAX_CONVERSIONS,
    [BID_STRATEGIES.MAX_CONVERSIONS]: bidStrategiesCategory.MAX_CONVERSIONS,
    [BID_STRATEGIES.MAX_VALUE]: bidStrategiesCategory.MAX_VALUE,
    [BID_STRATEGIES.BID_MODIFIER]: bidStrategiesCategory.BID_CONTROL,
};

export const useBidStrategiesOptions = ({ bidStrategyCategory, availableBidStrategies }) => {
    const availableCategories = useMemo(
        () =>
            uniqBy(
                values(availableBidStrategies).map(({ id, ...rest }) => {
                    const strategyCategory = strategyToCategoryMap[id];
                    return {
                        ...rest,
                        value: strategyCategory,
                        label: bidStrategiesCategory[strategyCategory],
                    };
                }),
                'value'
            ),
        [availableBidStrategies]
    );

    const bidStrategyOptions = useDropdownOptions(availableCategories, 'campaign.editor.bid.strategy.category');
    const selectedValue = useDropdownValue({ value: bidStrategyCategory }, 'campaign.editor.bid.strategy.category');

    return {
        bidStrategyOptions,
        selectedValue: bidStrategyCategory ? selectedValue : null,
    };
};
